import styled from 'styled-components';
import LandingWrapper from '../LandingWrapper/LandingWrapper';
import Triangle from '../Triangle/Triangle';
import { HeaderWrapper } from '../HeaderWrapper/HeaderWrapper';
import { Paragraph } from '../Paragraph/Paragraph';
import { Button } from '../Button/Button';
import PackCard from './PackCard/PackCard';
import SkiImg from './assets/SkiImg.png';
import TravelImg from './assets/TravelImg.png';

const PacksSection = () => {
  const title = 'Are you a tireless traveler or a sports explorer?';
  const paragraph = 'Discover our exclusive packages designed for your adventures.';
  const bottomParagraph = 'Already have your OnCampus Abroad insurance?';
  const buttonText = 'Add a pack';
  const buttonHref = '/onboarding?extendedInsurance=true';
  const linkHref =
    'https://main.oncampusabroad.com/media/documents/OnCampus_Extension-Packages_conditions.pdf';
  const linkText = 'Read packages conditions';
  const buttonId = 'ProductPolicy_extendMyInsurance_Button';
  const anchorId = 'PackageConditions_link';

  const infoPack =
    "To purchase your package, you first need to have your OnCampus Abroad insurance in place. Once payment is confirmed, you'll be directed to select the package that best suits your needs.";

  const packs = [
    {
      title: 'Sport Pack',
      description:
        'OnCampus Abroad already includes coverage for many common sports. But if you’re planning to try something more adventurous like skiing, snowboarding, or other high-risk activities - you can add our Sports Pack for just 85€ more and enjoy your favorite sports with peace of mind.',
      image: SkiImg,
      infoPack,
      color: '#05C793',
    },
    {
      title: 'Holiday Pack',
      description:
        'OnCampus Abroad already covers leisure trips of up to 5 days outside your academic destination country. If you wish to travel for a longer period, world-wide and up to 30 days, extend your coverage for only 80€.',
      image: TravelImg,
      infoPack,
      color: '#FFE177',
    },
  ];

  return (
    <>
      <Background>
        <Triangle color=' #fff6ef' />
        <LandingWrapper>
          <HeaderWrapper titleText={title} paragraphText={paragraph} />
        </LandingWrapper>
        <PacksWrapper>
          {packs.map((pack, index) => (
            <PackCard
              key={index}
              image={pack.image}
              title={pack.title}
              description={pack.description}
              info={pack.infoPack}
              color={pack.color}
            />
          ))}
        </PacksWrapper>
        <BottomWrapper>
          <Paragraph text={bottomParagraph} />
          <Button maxWidth='280px' href={buttonHref} id={buttonId}>
            {buttonText}
          </Button>
          <Link href={linkHref} target='_blank' rel='noopener noreferrer' id={anchorId}>
            {linkText}
          </Link>
        </BottomWrapper>
        <Triangle color=' #fff6ef' orientation='bottom' />
      </Background>
    </>
  );
};

export default PacksSection;

const Background = styled.div`
  width: 100%;
  background-color: #fff6ef;
  padding: 2rem;
  position: relative;
  padding-bottom: 80px;
  margin-top: 80px;

  @media (min-width: 768px) {
    padding-bottom: 180px;
  }

  @media (min-width: 1024px) {
    padding-bottom: 200px;
  }
`;

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  @media (min-width: 768px) {
    gap: 30px;
  }

  @media (min-width: 1024px) {
    gap: 30px;
  }
`;

const Link = styled.a`
  color: #283288 !important;
  font-size: 18px;
  font-weight: 400;

  &:hover {
    color:darkenColor(backgroundColor, 0.08)};
    font-weight: 400;
  }
`;

const PacksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  margin: 40px 0;

  @media (min-width: 768px) {
    flex-direction: column;
    justify-content: center;
    gap: 100px;
    margin: 40px 0 54px 0;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 80px;
    margin: 60px 0 200px 0;
  }

  @media (min-width: 1240px) {
    flex-direction: row;
    gap: 180px;
    margin: 60px 0 200px 0;
  }
`;
